module.exports = __webpack_public_path__ + "img/xlsx-file.963b3aff.svg";